export default __webpack_public_path__ + "static/media/barcode.e20d3b4f.svg";